var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImagePicture(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.62109 9.66602L4.67828 6.60883C5.19898 6.08813 6.0432 6.08813 6.5639 6.60882L9.62109 9.66602M8.28776 8.33268L9.34495 7.27549C9.86565 6.75479 10.7099 6.75479 11.2306 7.27549L12.2878 8.33268M8.28776 4.33268H8.29443M2.95443 12.3327H10.9544C11.6908 12.3327 12.2878 11.7357 12.2878 10.9993V2.99935C12.2878 2.26297 11.6908 1.66602 10.9544 1.66602H2.95443C2.21805 1.66602 1.62109 2.26297 1.62109 2.99935V10.9993C1.62109 11.7357 2.21805 12.3327 2.95443 12.3327Z",
    stroke: "#667085",
    strokeWidth: 1.41085,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagePicture);
export default __webpack_public_path__ + "static/media/image-picture.a2b47f8799a272c71c84acac6df0db91.svg";
export { ForwardRef as ReactComponent };